import React, { PureComponent } from 'react'
import { Table, Collapse } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { MY_VERIFY_INFO_URL } from '../../config'

class TxBusinessInfo extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      open: true,
    }
  }

  render() {
    const { state, props } = this
    const chevronClass = state.open ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
    const borderRadius = state.open ? '10px 10px 0 0' : '10px 10px 10px 10px'
    return (
      <div className='ibox float-e-margins animated fadeIn section-shadow'>
        <div
          onClick={() => this.setState({ open: !state.open })}
          className='ibox-title'
          style={{ borderRadius, cursor: 'pointer' }}
        >
          <i style={{ width: '10px' }} className={chevronClass} />
          <header>Additional User Information</header>
        </div>
        <Collapse in={state.open}>
          <div>
            <div style={{ borderRadius: '0 0 10px 10px' }} className='ibox-content table-responsive'>
              <Table striped bordered hover>
                <tbody>
                  <tr>
                    <th style={{ width: '15%' }}>Business</th>
                    <td>
                      {props.data.business && (
                        <Link to={`/business/${props.data.business}`}>{props.data.business}</Link>
                      )}{' '}
                      {props.data.business && (
                        <CopyToClipboard text={`${MY_VERIFY_INFO_URL}/business-onboarding/${props.data.business}`}>
                          <span style={{ marginLeft: '10px' }} className='cursor-pointer' title='Copy Onboarding URL'>
                            <i className='fa fa-copy' /> Onboarding URL
                          </span>
                        </CopyToClipboard>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>Investor Type</th>
                    <td>{props.data.investor_type}</td>
                  </tr>
                  <tr>
                    <th>Accredited Investor?</th>
                    <td>{props.data.is_accredited_investor ? 'Yes' : 'No'}</td>
                  </tr>
                  <tr>
                    <th>Insurance License</th>
                    <td>{props.data.insurance_license}</td>
                  </tr>
                  <tr>
                    <th>Medical License</th>
                    <td>{props.medical_license}</td>
                  </tr>
                  <tr>
                    <th>Signer Type</th>
                    <td>{props.data.signer_type}</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div>
        </Collapse>
      </div>
    )
  }
}

export default TxBusinessInfo
